import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import { useAppStore } from '@/stores/app'

// Login/PIN endpoints answer 401 for a wrong code — that must not log the person out.
const AUTH_PATHS = ['/login-operator', '/login-admin', '/change-pin']

// This app has no separate /login route — the whole app stays mounted and a
// full-screen lock overlay (see layouts/components/LockOverlay.vue) covers it
// when not authenticated. A 401 just logs out; the overlay reacts to that.
export const useFetchStore = defineStore('fetch', () => {
  const appStore = useAppStore()

  const fetch = createFetch({
    baseUrl: '/api/sortiranje/v1',
    options: {
      beforeFetch({ options }) {
        options.headers = new Headers(options.headers)
        options.headers.set('Authorization', `Bearer ${appStore.getJWT()}`)
        return { options }
      },
      onFetchError(ctx) {
        const url = ctx.response?.url ?? ''
        if (ctx.response?.status === 401 && !AUTH_PATHS.some((path) => url.endsWith(path))) {
          appStore.setLogout()
        }
        return ctx
      },
    },
  })

  return { fetch }
})
